export const subscriptionEn = {};

export const subscriptionFr = {};
